import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { Wrapper, Header, Title, Content, Text, IconWrapper } from './styles';
import ArrowDown from '@spa/shared/svg/arrowDown';

const Accordion = ({
  title,
  subTitle,
  resume,
  description,
  url,
  urlText,
  Icon,
  onOpen = () => {},
  isStatic = false,
  isInitiallyOpen = false,
  hideChevron = false,
  isDisabled = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(isStatic || isInitiallyOpen);
  const toggle = useCallback(() => (!isStatic && !isDisabled ? setIsOpen(!isOpen) : null), [isOpen, isStatic]);

  const hasResume = resume && resume.length;

  return (
    <Wrapper onClick={!isOpen && !isStatic ? () => onOpen(title) : null} {...props}>
      <Header onClick={toggle} className={isStatic ? 'static' : ''} {...props}>
        {Icon ? (
          <IconWrapper>
            <Icon />
          </IconWrapper>
        ) : null}
        {typeof title === 'string' ? <Title>{title}</Title> : title}
        {hasResume && <Text className={`resume ${isOpen ? 'hide' : 'show'}`}>{resume}</Text>}
        {!isStatic && !hideChevron ? (
          <ArrowDown className={`chevron ${isOpen ? 'open' : ''}`} onClick={toggle} />
        ) : null}
      </Header>
      <Content className={isOpen ? 'open' : ''} hasIcon={!!Icon}>
        <Text>
          {typeof description === 'string' ? <p>{description}</p> : description}
          {url ? (
            <Link href={url} target="_blank" rel="noopener noreferrer">
              {urlText ? urlText : url}
            </Link>
          ) : null}
        </Text>
      </Content>
    </Wrapper>
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subTitle: PropTypes.string,
  resume: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  url: PropTypes.string,
  urlText: PropTypes.string,
  Icon: PropTypes.func,
  onOpen: PropTypes.func,
  isStatic: PropTypes.bool,
  isInitiallyOpen: PropTypes.bool,
  hideChevron: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default Accordion;
